import {ReactNode} from 'react'

import {UserInfoProvider} from '$contexts/member/userInfoStatus'
import {ValidAppProvider} from '$hooks/useValidApp'
import {UserInfo} from '$types/member'

export interface InsurancePageProps {
    userInfo: UserInfo
    isValidApp: boolean
}
export default function InsurancePageProvider({
    userInfo,
    isValidApp,
    children,
}: InsurancePageProps & {
    children: ReactNode
}) {
    return (
        <UserInfoProvider userInfo={userInfo}>
            <ValidAppProvider initialValue={isValidApp}>{children}</ValidAppProvider>
        </UserInfoProvider>
    )
}
